import InviteCodeCreateView from 'src/sections/management/invite-code/view/invite-code-create-view';

export default function InviteCodeCreate() {
  return <InviteCodeCreateView />;
}
